import React from 'react';

export default function ReservationIcon(props) {
  return (
    <img
      src="/assets/files/questions/reservation.svg"
      alt="Reservation question"
      {...props}
    />
  );
}
